import styled from "styled-components"

export const Box = styled.div`
  font-family: ${props => props.theme.primaryFont}, sans-serif;
  background-color: ${props => props.bgColor};
  border-radius: 2rem;
  height: 100%;
  box-sizing: border-box;

  font-size: 170%;
  font-weight: 600;
  padding: 2% 0 5% 0;
`
export const PositionList = styled.ol`
  padding: 0 5%;
  background-color: ${props => props.bgColor};
  color: ${props => props.fontColor};

  display: flex;
  flex-direction: column;
  align-items: center;

  margin: 5% 0;
`
export const PositionListItem = styled.li`
  display: inline-flex;

  /* Highlighted list item is wider...  */
  width: ${props => props.isHighlighted ? 125 : 100}%;
  /* ...has more padding (to align w/ other items)... */
  padding: 1.75% ${props => props.isHighlighted ? 12.5 : 0}%;
  /* ...has highlighted color... */
  background-color: ${props => props.isHighlighted ? props.highlightColor : "none"};
  /* ...and rounded borders */
  border-radius: ${props => props.isHighlighted ? 2 : 0}rem;

  box-sizing: border-box;
`
export const RankDescription = styled.p`
  font-weight: 400;
`
export const Title = styled.h2`
  color: ${props => props.fontColor};
`
export const Name = styled.span``
export const Score = styled.div`
  margin-left: auto;
  font-weight: 200;
`
export const Header = styled.div`
  padding: 2% 11% 0 11%;
  * {
    margin: 0;
  }
`
export const Index = styled.span`
  margin-right: 2%;
`